module.exports = __webpack_public_path__ + "img/download.3aea426d.svg";